import { computed } from 'vue'

export function useMode(props) {
  const isEditMode = computed(() => props.mode === 'edit')
  const isViewMode = computed(() => props.mode === 'view')

  return {
    isEditMode,
    isViewMode,
  }
}